/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Delete_Personal_ErrorInputs */



/**
* | output |
* | --- |
* | "Cannot delete personal project" |
*
* @param {Projects_Delete_Personal_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const projects_delete_personal_error = /** @type {((inputs?: Projects_Delete_Personal_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Delete_Personal_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Persönliches Projekt kann nicht gelöscht werden")
	return /** @type {LocalizedString} */ ("Cannot delete personal project")
});